import { lt } from '@mews/framework';

export enum ReservationsTableColumns {
    Space = 'Space',
    Customer = 'Customer',
    Loyalty = 'Loyalty',
    Classifications = 'Classifications',
    Arrival = 'Arrival',
    Departure = 'Departure',
    Products = 'Products',
    Notes = 'Notes',
    Companions = 'Companions',
    CompanionLoyalty = 'CompanionLoyalty',
    CompanionClassifications = 'CompanionClassifications',
    CarRegistrationNumber = 'CarRegistrationNumber',
    Preauthorizations = 'Preauthorizations',
    Balance = 'Balance',
    VerificationPhoto = 'VerificationPhoto',
}

export const loyaltyColumns = [
    { value: ReservationsTableColumns.Loyalty, label: lt('GuestInHouseReportColumnLoyaltyPrograms') },
    {
        value: ReservationsTableColumns.CompanionLoyalty,
        label: lt('GuestInHouseReportColumnCompanionLoyaltyPrograms'),
    },
];

export const nonLoyaltyHideableColumns = [
    { value: ReservationsTableColumns.Classifications, label: lt('Classifications') },
    { value: ReservationsTableColumns.Products, label: lt('Products') },
    { value: ReservationsTableColumns.Notes, label: lt('Notes') },
    {
        value: ReservationsTableColumns.CompanionClassifications,
        label: lt('GuestInHouseReportColumnCompanionClassifications'),
    },
    { value: ReservationsTableColumns.CarRegistrationNumber, label: lt('CarRegistrationNumber') },
    { value: ReservationsTableColumns.Preauthorizations, label: lt('GuestInHouseReportColumnPreauthorizations') },
    { value: ReservationsTableColumns.Balance, label: lt('GuestInHouseReportColumnBalance') },
    { value: ReservationsTableColumns.VerificationPhoto, label: lt('GuestInHouseReportColumnVerificationPhoto') },
];

// TODO: Clarify the options ordering, add ordering support if required
export const hideableColumns = [...loyaltyColumns, ...nonLoyaltyHideableColumns];
